{
  "$schema": "../../../../../output/examples/plugin-demo-schema.json",
  "name": "docx",
  "props": {
    "title": "Weather Plugin Demo"
  },
  "children": [
    {
      "name": "section",
      "props": {
        "meta": {
          "title": "Today"
        }
      },
      "children": [
        {
          "name": "heading",
          "props": {
            "text": "Today",
            "level": 1,
            "spacing": { "before": 0, "after": 0 }
          }
        },
        {
          "name": "paragraph",
          "props": {
            "content": "Each block below is rendered by the weather plugin, which calls Open-Meteo while the document is generated."
          }
        },
        {
          "name": "weather",
          "version": "1.0.0",
          "props": {
            "city": "Milan",
            "units": "metric",
            "showDetails": true
          }
        },
        {
          "name": "weather",
          "version": "1.0.0",
          "props": {
            "city": "New York",
            "units": "imperial",
            "showDetails": false
          }
        }
      ]
    },
    {
      "name": "section",
      "props": {
        "meta": {
          "title": "The week ahead"
        }
      },
      "children": [
        {
          "name": "heading",
          "props": {
            "text": "The week ahead",
            "level": 1,
            "spacing": { "before": 0, "after": 0 }
          }
        },
        {
          "name": "weather",
          "version": "2.0.0",
          "props": {
            "city": "Tokyo",
            "units": "metric",
            "days": 5
          }
        }
      ]
    }
  ]
}
